// extracted by mini-css-extract-plugin
export default {"premium":"YM4X74QP","mobile":"mobile","top":"tpb9BiWg","media":"Ft27zsrO"};